import "./Partners.module.css";
import Header from "@/reusable_sections/Header";
import OurVenuePartners from "./sections/OurVenuePartners";
import GrabATable from "./sections/GrabATable";
import RejoignezLAventure from "@/reusable_sections/Footer";
import { UnderConstruction } from "@/pages/UnderConstruction/UnderConstruction";
export default function PartnersPage() {
  return (
    // <div>
    //   <Header />
    //   <OurVenuePartners />
    //   <GrabATable />
    //   <RejoignezLAventure />
    // </div>

    <div className="container mx-auto py-12">
      <UnderConstruction />
    </div>
  );
}